<div class="alert alert-danger d-flex">
	<mat-icon class="d-flex my-auto mx-2">warning</mat-icon>
	{{ message }}
</div>
